import { InsertLinkFRECallout } from 'owa-editor-ribbon-secondary-ui';
import { LightningId } from 'owa-lightning-v2';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

// Timeout for the FRE
function when(lightup: () => void) {
    setTimeout(lightup, 500);
}

function showInsertLinkTeachingMoment(IsForNewCompose: boolean) {
    const document = window.document;
    const targetElement = document.getElementById('insertMenuItem');
    if (targetElement) {
        const lightningId = IsForNewCompose
            ? LightningId.InsertLinkFREOpenCompose
            : LightningId.InsertLinkFREAfterAttach;
        const insertLinkFreDiv = document.createElement('div');
        insertLinkFreDiv.id = 'insertLinkFre';
        document.body.appendChild(insertLinkFreDiv);

        ReactDOM.render(
            <React.StrictMode>
                <InsertLinkFRECallout lid={lightningId} when={when} target={targetElement} />
            </React.StrictMode>,
            insertLinkFreDiv
        );
    }
}

export default showInsertLinkTeachingMoment;
